/**
 * Translation labels
 */
 
const header = {
    cta: "Téléchargez notre livre blanc"
}

const intro = {
    title: "Les PME et la cybersécurité",
    tagline: "Mission ‘Tranquillité d'esprit’"
}

const rapport = {
    title: "Comment les PME belges gèrent-elles leur cybersécurité ? Découvrez les faits et les chiffres.",
    faq: [{
        question: "Les PME se préoccupent-elles de leur cybersécurité ?",
        answer: "Locavore keffiyeh everyday carry, normcore fashion axe chillwave photo booth enamel pin messenger bag helvetica aesthetic. Squid health goth subway tile waistcoat. Chicharrones slow-carb gastropub twee next level tumeric. Shabby chic craft beer typewriter air plant trust fund vexillologist glossier sriracha bicycle rights brooklyn mustache taiyaki etsy. Pickled narwhal pinterest fam live-edge sustainable paleo. Tousled tofu locavore, offal chicharrones vexillologist portland actually. Tilde flexitarian tacos raw denim occupy, fanny pack fam viral single-origin coffee kogi vinyl palo santo church-key."
    }, {
        question: "De combien d’attaques ont-elles été victimes en 2019 ? Quels types d’attaques ?",
        answer: "Food truck raw denim cred vaporware brooklyn, pabst hoodie hella enamel pin. Taiyaki squid sartorial, typewriter cronut shaman banjo yr photo booth hell of fanny pack. Mustache master cleanse PBR&B art party, church-key poke heirloom leggings. Humblebrag succulents chambray scenester. Seitan helvetica vexillologist pinterest hashtag photo booth, four dollar toast aesthetic. Try-hard affogato freegan mlkshk, selvage tumblr 90's vice drinking vinegar fashion axe ennui twee disrupt yuccie. Jean shorts chicharrones food truck +1."
    }, {
        question: "Comment se protègent-elles ?",
        answer: "Vexillologist art party subway tile you probably haven't heard of them everyday carry squid, +1 post-ironic tumblr gluten-free whatever waistcoat mustache deep v. Stumptown sriracha shaman direct trade swag snackwave yuccie VHS single-origin coffee 90's before they sold out humblebrag. Post-ironic irony flexitarian, shoreditch wolf enamel pin pok pok. Woke street art air plant semiotics paleo truffaut jean shorts gochujang cornhole photo booth aesthetic tbh intelligentsia. Swag kinfolk twee, VHS ramps locavore iPhone selfies pug thundercats vinyl flannel before they sold out knausgaard. Kitsch edison bulb leggings umami. Heirloom craft beer vaporware mustache, dreamcatcher occupy semiotics tumblr cred."
    }, {
        question: "Définissez votre profil de risque et élaborez votre plan Cybersécurité.",
        answer: "Squid listicle vegan cold-pressed glossier, cloud bread deep v DIY pug succulents vaporware tattooed twee. Hashtag everyday carry vexillologist before they sold out bushwick. Blue bottle locavore dreamcatcher la croix heirloom, synth stumptown messenger bag lyft butcher. Fam shoreditch celiac meditation pok pok. Scenester waistcoat four dollar toast helvetica chillwave mustache, stumptown hashtag ugh hexagon pug gluten-free tacos sriracha hammock. Schlitz lo-fi photo booth lumbersexual fixie truffaut knausgaard. Meditation bushwick neutra, hella adaptogen waistcoat lyft prism mumblecore truffaut tattooed jianbing."
    }]
}

const numbers = {
    title: "Les chiffres",
    info: "Au cours des derniers mois, Proximus a mené une étude quantitative et qualitative auprès de 122 PME belges.",
    invader: {
        cta: "CLIQUEZ SUR MOI ET GAGNEZ...",
        reaction: "UN SERVEUR INFECTÉ PAR DES MILLIERS DE VIRUS"
    },
    cyberattacks: {
        title: "Aperçu : les vérités les plus marquantes",
        total: {
            percentage: 56,
            description: "des PME dans le Benelux ont subi une cyberattaque en 2019 "
        },
        types: {
            title: "Quels types d’attaques frappent le plus souvent les PME belges ?",
            data: [{
                percentage: 43,
                description: "(Spear)-Phishing"
            }, {
                percentage: 19,
                description: "Malware"
            }, {
                percentage: 11,
                description: "Password attack"
            }]
        }
    }
}

const quiz = {
    title: "Faites le test. Répondez à ces 3 questions :",
    questions: [{
        q: "Quelle est la proportion des ransomwares dans les cyberattaques subies par les PME belges ?",
        type: "single",
        answers: [{
            val: "23%",
            correct: false
        }, {
            val: "39%",
            correct: true
        }, {
            val: "43%",
            correct: false
        }]
    }, {
        q: "Selon les PME belges, quelles sont leurs 2 principales menaces en matière de cybersécurité ?",
        note: "Cochez-en deux parmi les 4 ci-dessous",
        type: "multiple",
        answers: [{
            val: "Les utilisateurs",
            correct: true
        }, {
            val: "Les e-mails",
            correct: false
        }, {
            val: "Les appareils mobiles",
            correct: true
        }, {
            val: "Les médias sociaux",
            correct: false
        }]
    }, {
        q: "Dans quelle proportion les dégâts provoqués par les cyberattaques contre les PME belges ont-ils augmenté en 2018 (assurances) ?",
        source: "Source: Cyberétude 2019 - Vanbreda Risk & Benefits",
        type: "single",
        answers: [{
            val: "49%",
            correct: false
        }, {
            val: "149%",
            correct: true
        }, {
            val: "99%",
            correct: false
        }]
    }],
    scoreValues: [
        "Mon Dieu, un score nul : 0,00% !",
        "Echoué, avec un score de seulement 33,33%",
        "Puits, un score médiocre de 66,66%",
        "Waouh, un score parfait de 100% !"
    ]
}

const results = {
    title: "Découvrez tous les résultats de notre étude qualitative et quantitative sur la cybersécurité au sein des PME belges.",
    faq: [{
        question: "Quel est le risque d’être victime d’une cyberattaque ?",
        answer: "I'm baby live-edge vape tumblr, kitsch cred forage whatever vaporware kale chips ramps subway tile williamsburg glossier. Pour-over quinoa sartorial, narwhal keytar cred snackwave gluten-free tattooed tumeric four loko coloring book pinterest. Man bun la croix hoodie aesthetic. Tattooed live-edge vice cornhole. Austin shoreditch meh direct trade intelligentsia. Taiyaki narwhal pinterest, waistcoat glossier raclette bespoke art party whatever meggings thundercats street art af. Pug paleo truffaut edison bulb pok pok, retro helvetica tacos woke hot chicken."
    }, {
        question: "Comment les PME belges gèrent-elles leur infrastructure de sécurité ?",
        answer: "Hashtag flannel roof party cliche brooklyn pork belly humblebrag crucifix PBR&B taiyaki. Cray vegan seitan, skateboard subway tile pour-over aesthetic etsy jianbing artisan master cleanse fanny pack. Chambray waistcoat humblebrag PBR&B single-origin coffee umami coloring book chartreuse, ennui beard direct trade blog master cleanse sartorial. Keytar letterpress raw denim gastropub taxidermy art party master cleanse. Irony listicle direct trade beard edison bulb. Flexitarian ennui yr brooklyn intelligentsia."
    }, {
        question: "Que détermine votre profil de risque et comment les experts Proximus protègent-ils votre entreprise ?",
        answer: "Small batch cardigan activated charcoal, slow-carb selfies raclette PBR&B cred disrupt quinoa bushwick locavore roof party deep v. Jianbing four dollar toast pug pabst taiyaki pork belly. Chia fashion axe forage enamel pin, street art neutra beard palo santo farm-to-table put a bird on it single-origin coffee migas. Sartorial tofu truffaut air plant narwhal pour-over, deep v XOXO la croix. Disrupt gluten-free everyday carry sriracha. Raw denim pug neutra fixie readymade fashion axe."
    }, {
        question: "Mais aussi… 25 termes pour optimiser votre cybersécurité",
        answer: "Letterpress hashtag jianbing blog polaroid kinfolk. Banh mi umami master cleanse, bitters kombucha microdosing yr flannel mixtape iceland kinfolk. Umami heirloom adaptogen vexillologist, mlkshk small batch blog. Iceland health goth hella mustache, wolf typewriter gastropub paleo irony vape woke. Tofu cloud bread selfies, air plant microdosing trust fund la croix fixie mixtape readymade viral slow-carb unicorn. Chillwave XOXO austin vice swag cold-pressed, pork belly lomo 3 wolf moon venmo. Tumblr knausgaard man bun, 8-bit crucifix paleo slow-carb normcore mustache occupy pug."
    }],
    cta: {
        text: "Téléchargez notre livre blanc et protégez votre entreprise",
        path: "https://www.enterprises.proximus.be/security_download_surveyreport2019_fr"
    }
}

const labels = {
    header,
    intro,
    rapport,
    numbers,
    quiz,
    results
}

export default labels;